import { ChangeDetectionStrategy, Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { PasswordType } from '../../models/PasswordType.model';

const noop = () => { };

@Component({
	selector: 'app-password',
	templateUrl: './password.component.html',
	styleUrls: ['./password.component.scss'],
	providers: [{
		provide: NG_VALUE_ACCESSOR,
		useExisting: forwardRef(() => PasswordComponent),
		multi: true
	}],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class PasswordComponent implements ControlValueAccessor {

	@Input() public showLabel: boolean = true;
	@Input() public markForCheck: boolean;
	public type: PasswordType = 'password';
	public isDisabled: boolean;

	constructor() { }

	private _value: string;
	public registerOnTouched: () => void = noop;
	private onChange: (_: any) => void = noop;

	public get value(): string {
		return this._value;
	}

	@Input() public set value(val: string) {
		this._value = val;
		this.onChange(this._value);
	}

	public showHidePassword(type: PasswordType): void {
		this.type = type === 'password' ? 'text' : 'password';
	}

	public writeValue(value: any): void {
		this.value = value;
	}

	public registerOnChange(fn: any): void {
		this.onChange = fn;
	}

	public setDisabledState(isDisabled: boolean): void {
		this.isDisabled = isDisabled;
	}
}